
import Vue from "vue";
import { api, BudgetBucket, PurchaseAdviceResponse } from "@/services/api";

export default Vue.extend({
    data() {
        return { description: "", amount: null as number | null, notes: "", budgetBucketId: null as number | null, includeSensitive: false, buckets: [] as BudgetBucket[], result: null as PurchaseAdviceResponse | null, checking: false, savingMemories: false, memoriesSaved: false, error: "" };
    },
    computed: {
        verdictLabel(): string {
            const labels: {[key: string]: string} = { buy: "Buy", wait: "Wait", skip: "Skip", "needs-more-info": "Needs more info" };
            return this.result ? labels[this.result.advice.verdict] : "";
        }
    },
    async mounted() { this.buckets = await api.getBudgetBuckets(); },
    methods: {
        async check() {
            this.checking = true; this.error = ""; this.result = null; this.memoriesSaved = false;
            try {
                this.result = await api.getPurchaseAdvice({ description: this.description, amountCents: this.amount ? Math.round(this.amount * 100) : null, merchant: "", notes: this.notes, budgetBucketId: this.budgetBucketId, includeSensitive: this.includeSensitive });
            } catch (error) { this.error = error instanceof Error ? error.message : "Unable to get purchase advice."; }
            finally { this.checking = false; }
        },
        async saveMemories() {
            if (!this.result) return;
            this.savingMemories = true;
            const changes = this.result.advice.suggestedMemoryUpdates.slice(0, 2);
            try { this.memoriesSaved = await api.applyAgentMemoryChanges(changes); if (!this.memoriesSaved) this.error = "Unable to save suggested memories."; }
            finally { this.savingMemories = false; }
        }
    }
});
